import { Nilable } from "@shared/utils";
import { CodigoValorDTO, ICodigoValorDTO } from "./CodigoValor.DTO";
import { ClienteDTO } from "./Cliente.DTO";

export interface ICodigoDTO extends ICodigoValorDTO {
    id: number;
    customer: number;
    code: string;
    created_at: string;
    redeemed_on: Nilable<string>;
}

export class CodigoDTO extends CodigoValorDTO {
    public id = 0;
    public cliente = new ClienteDTO();
    public codigo = "";
    public creadoEl = new Date();
    public canjeadoEl: Nilable<Date>;

    constructor(json: Nilable<ICodigoDTO> = null) {
        super();
        if (json != null) {
            this.cargarDTO(json);
        }
    }


    public cargarDTO(json: ICodigoDTO) {
        super.cargarDTO(json);
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.customer != null) {
            this.cliente = new ClienteDTO({ id: json.customer });
        }
        if (json.code != null) {
            this.codigo = json.code;
        }
        if (json.created_at != null) {
            this.creadoEl = new Date(json.created_at);
        }
        if (json.redeemed_on != null) {
            this.canjeadoEl = new Date(json.redeemed_on);
        }
    }

    public toJSON(): ICodigoDTO {
        return {
            id: this.id,
            customer: this.cliente.id,
            code: this.codigo,
            created_at: this.creadoEl.toJSON(),
            redeemed_on: this.canjeadoEl?.toJSON() ?? null,
            ...super.toJSON()
        };
    }

}
